import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconCollection} from '../../utilities/iconimport';
import React from 'react';
import './checkbox.scss';

interface CheckboxProps {
  checkboxId: string;
  onChange?: (e: any) => any;
  disabled?: boolean;
  isChecked?: boolean;
  text: string;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return (
    <div className="br-checkbox">
      <input type="checkbox"
             onChange={props.onChange}
             id={props.checkboxId}
             disabled={props.disabled}
             checked={props.isChecked}
             data-testid={props.text}
            />
      <label htmlFor={props.checkboxId} className="br-checkbox_label">
        <FontAwesomeIcon icon={IconCollection.checkIcon} className="br-checkbox_icon"/>
        <span className="br-checkbox_label-text">{props.text}</span>
      </label>
    </div>
  );
};
